import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'

import toast from 'react-hot-toast'
import styled from 'styled-components'
import moment from 'moment'

import EmojiCollection from './components/EmojiCollection'
import FeedbackQuestions from './components/FeedbackQuestions'

import { baseUrl } from '../../../../constants/constant'

import { PagesContext } from '../../../../context/FormPagesContext'

import { H2, P } from '../../../../styles/Typograph.styles'

import { getFromSessionStorage } from '../../../../utils/util'

const ExperienceSurvey = () => {
  const [activeEmoji, setActiveEmoji] = useState(5)
  const [feedback, setFeedback] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [questions, setQuestions] = useState([])
  const [lastInterview, setLastInterview] = useState({})

  const { userData } = useContext(PagesContext)

  useEffect(() => {
    const timer = setTimeout(() => {
      axios
        .get(`${baseUrl}/check-feedback-submission`, {
          headers: {
            Authorization: `Bearer ${getFromSessionStorage('token')}`,
          },
          params: {
            user_id: userData?.id,
          },
        })
        .then((res) => {
          const response = res?.data?.result

          if (response.length > 0) {
            setLastInterview(response[0])
            setShowModal(true)
          }
        })
        .catch((err) => {
          toast.error(
            err?.response?.data ||
              err?.response?.data?.message ||
              'Something went wrong'
          )
        })
    }, 10000) // 10 seconds

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (showModal) {
      axios
        .get(`${baseUrl}/feedback-questions`, {
          headers: {
            Authorization: `Bearer ${getFromSessionStorage('token')}`,
          },
        })
        .then((res) => {
          const response = res?.data?.result
          const defaultQuestions = response?.map((question) => ({
            id: question.id,
            question: question.question,
            answer: 1,
          }))
          setQuestions(defaultQuestions)
        })
        .catch((err) => {
          toast.error(
            err?.response?.data ||
              err?.response?.data?.message ||
              'Something went wrong'
          )
        })
    }
  }, [showModal])

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)

    const token = getFromSessionStorage('token')

    const data = {
      emoji: activeEmoji?.toString(),
      user_id: userData?.id?.toString(),
      interview_id: lastInterview?.interview_id?.toString(),
      feedback_questions: JSON.stringify(questions),
      experience: feedback,
    }

    axios
      .post(`${baseUrl}/feedback`, data, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((res) => {
        setIsLoading(true)
        toast.success(res?.data.message || 'Feedback sent successfully')
        setShowModal(false)
      })
      .catch((err) => {
        setIsLoading(false)
        toast.error(
          err?.response?.data?.message ||
            err?.response.data ||
            'Something went wrong, Some field not field.'
        )
      })
  }

  const handleQuestions = (id, value) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === id) return { ...question, answer: value }
      return question
    })

    setQuestions(updatedQuestions)
  }

  return (
    <StyledModal className={showModal ? 'show' : ''}>
      <div onClick={() => setShowModal(false)} className="overlay" />
      <div className="content">
        <H2 weight="500" size="1.5rem" align="left">
          Applicant Experience Survey
        </H2>

        <P>
          {`Hello ${lastInterview?.applicant_name} 👋,`}
          {
            <>
              <br />
              <br />
            </>
          }{' '}
          {`You recently completed your interview for the ${
            lastInterview?.job_title
          }
          position on ${moment(lastInterview?.interview_date).format(
            'MMMM Do YYYY'
          )}. As part of our commitment to improving
          our recruitment process, We’d greatly appreciate it if you could take
          a moment to share feedback about your experience. Your insights are
          valuable and will help us enhance our hiring journey for future
          candidates.`}
        </P>

        <EmojiCollection value={activeEmoji} setValue={setActiveEmoji} />
        <FeedbackQuestions
          questions={questions}
          handleQuestions={handleQuestions}
        />

        <P weight="500">Tell us about your experience (optional)</P>
        <textarea
          onChange={(e) => setFeedback(e.target.value)}
          className="textarea"
        ></textarea>

        <div className="modal-footer">
          <button onClick={() => setShowModal(false)} className="btn btn-close">
            Cancel
          </button>
          <button onClick={handleSubmit} className="btn btn-primary">
            {isLoading ? 'Loading...' : 'Submit'}
          </button>
        </div>
      </div>
    </StyledModal>
  )
}

export default ExperienceSurvey

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
  justify-content: center;
  align-items: center;

  &.show {
    display: flex;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .content {
    position: relative;
    z-index: 4;
    width: 100%;
    max-width: 588px;
    height: 100%;
    background: #fff;
    padding: 2.5rem 2rem;
    overflow-y: scroll;

    .textarea {
      width: 100%;
      height: 6rem;
      outline: none;
      padding: 1rem;
      border: 1px solid #e8d6da;
      margin-top: 10px;
    }

    .modal-footer {
      margin-top: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn {
        font-size: 0.75rem;
        font-weight: 400;
        color: #858aa0;
        padding: 0.75rem 1.3rem;
        border-radius: 100px;
        background: none;
        outline: none;
        cursor: pointer;

        &.btn-close {
          border: none;
        }

        &.btn-primary {
          border: 1px solid #ff7b9b;
          background: #ff7b9b;
          color: #fff;

          &:hover {
            background: none;
            color: #ff7b9b;
            border: 1px solid #ff7b9b;
          }
        }
      }
    }
  }
`
